import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { PagePanel, Tabs } from 'edenred-ui';

import { ReportTypeVirike } from '@epi-constants/externalReport';
import { TopupReports } from '@epi-pages/Reports/TopupReports';
import { BalanceCorrections } from '@epi-pages/Reports/BalanceCorrections';
import { LoadRequests } from '@epi-pages/Reports/LoadRequests';
import { CardOrders } from '@epi-pages/Reports/CardOrders';
import { Deposits } from '@epi-pages/Reports/Deposits';
import { getBalanceCorrectionsCheckRequest } from '@epi-api/balanceCorrections';
import { getApplicationLocale } from '@epi-store/application/application.selectors';
import { getUserCompany } from '@epi-actions/api';
import { getCustomerNumber } from '@epi-selectors/api';

import { useExternalReportsTabs } from './hooks/useExternalReportsTabs';

const ExternalReportsTabs = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const locale = useSelector(getApplicationLocale);
  const companyId = useSelector(getCustomerNumber);
  const [showBalanceCorrections, setShowBalanceCorrections] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { handleOnTabChange, defaultTabName } = useExternalReportsTabs();

  const updateBalanceCorrections = async () => {
    const response = await getBalanceCorrectionsCheckRequest();
    setShowBalanceCorrections(response);
  };

  useEffect(() => {
    dispatch(getUserCompany());
  }, []);

  useEffect(() => {
    setIsLoading(true);
    updateBalanceCorrections();
    setIsLoading(false);
  }, [locale]);

  const topUpLoads = {
    name: ReportTypeVirike.topups,
    label: t('containers.reports.tabs.topup'),
    id: 'tab-topup',
    body: <TopupReports />
  };

  const balanceCorrections = {
    name: ReportTypeVirike.corrections,
    label: t('containers.deposit_money.corrections_tab.title'),
    id: 'tab-balance-corrections',
    body: <BalanceCorrections />
  };

  const loadRequests = {
    name: ReportTypeVirike.loadRequests,
    label: t('containers.deposit_money.load_requests_tab.title'),
    id: 'tab-load-requests',
    body: <LoadRequests />
  };

  const cardOrders = {
    name: ReportTypeVirike.cardOrders,
    label: t('containers.deposit_money.card_orders_tab.title'),
    id: 'tab-card-orders',
    body: <CardOrders />
  };

  const deposits = {
    name: ReportTypeVirike.deposits,
    label: t('containers.deposit_money.deposits_tab.title'),
    id: 'tab-deposits',
    body: <Deposits />
  };

  const tabs = [
    cardOrders,
    topUpLoads,
    deposits,
    loadRequests,
    ...(showBalanceCorrections ? [balanceCorrections] : [])
  ];

  return (
    <PagePanel title={t('containers.reports.title')}>
      {!isLoading && companyId && (
        <Tabs
          tabs={tabs}
          onTabChange={handleOnTabChange}
          defaultTabName={defaultTabName}
        />
      )}
    </PagePanel>
  );
};

export default ExternalReportsTabs;
